// extracted by mini-css-extract-plugin
module.exports = {"icon":"Navbar_icon__iB1pm","gradient":"Navbar_gradient__2WqkO"};